import { Event } from "Global/Base/Events";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "../Controls/Control";
import { AlignType } from "../Controls/ControlEnums";
import { ControlParams } from "../Controls/ControlInterfaces";
import { AlignDockHelperContainer } from "./AlignPanels/AlignDockHelperContainer";
import { AlignDockHelperSelfContainer } from "./AlignPanels/AlignDockHelperSelfContainer";
import { AlignPanelValidation, AlignValidationResult } from "./AlignPanels/AlignPanelValidation";
import { BaseAlignElement } from "./AlignPanels/BaseAlignElement";
import { ControlElement } from "./AlignPanels/ControlElement";

export class AlignPanel extends Control {
    private _stylesheet: HTMLStyleElement;

    private _type: AlignValidationResult = AlignValidationResult.docking;
    private _baseAlignPanel: BaseAlignElement;

    public disposing: Event<this, void> = new Event<this, void>();

    constructor(params: ControlParams) {
        super(params);
        const { element: panel } = params;

        this._stylesheet = createElement({ type: "style" }) as HTMLStyleElement;
        document.head.appendChild(this._stylesheet);

        this._baseAlignPanel = new BaseAlignElement(panel);

        panel.classList.add("AlignPanel");
        panel.dataset.behaviour = "container";

        this._type = AlignPanelValidation.validate(this._baseAlignPanel);

        if (this._type === AlignValidationResult.docking)
            this._docking();
        else
            this._positioning();
    }

    private _docking(elements: HTMLElement[] = null): void {
        const children = elements ? elements : Array.from(this.element.children) as HTMLElement[];

        //let parentElement = this.Element;

        //for (let child of children) {
        //    const ch = new AlignDockHelperContainer(new BaseAlignElement(child), parentElement);
        //    const nparent = createElement({ classes: ["AlignDockHelperContainer"] });
        //    parentElement.appendChild(nparent);
        //    parentElement = nparent;
        //}
        let lastSide: AlignType | -1 = -1;
        const oneSideDock: BaseAlignElement[] = [];
        const otherSide: BaseAlignElement[] = [];
        for (const child of children) {
            const ch = new BaseAlignElement(child);
            if (ch.element.getAttribute("data-tscitem") && ch.element.getAttribute("data-tscitem").startsWith("Right"))
                continue;

            if (lastSide == -1) {
                if (ch.alignType != AlignType.client)
                    lastSide = ch.alignType;
            }

            if (/*lastSide == ch.alignType && */ch.alignType != AlignType.client) {
                oneSideDock.push(ch);
            } else {
                otherSide.push(ch);
            }
        }

        let parentElement = this.element;

        for (const child of oneSideDock) {
            new AlignDockHelperContainer(child, parentElement, this._stylesheet);
            if (otherSide.length > 0) {
                const nparent = createElement({ classes: ["AlignDockHelperContainer"] });
                parentElement.appendChild(nparent);
                parentElement = nparent;
            }
        }

        for (const child of otherSide) {
            new AlignDockHelperContainer(child, parentElement, this._stylesheet);
        }

        if (parentElement.children.length == 0)
            parentElement.remove();
    }

    private _positioning(): void {
        const children = Array.from(this.element.children) as HTMLElement[];
        const posElements: ControlElement[] = [];
        const dockElement: BaseAlignElement[] = [];

        this.element.classList.add("Positioned");

        for (const child of children) {
            const ch = new BaseAlignElement(child);
            if (AlignPanelValidation.isDockingElement(ch))
                dockElement.push(ch);
            else {
                if (ch.element.hasAttribute("data-tscitem")) {
                    const right = ch.element.getAttribute("data-tscitem");
                    if (right != null && right.toLowerCase().startsWith("rights."))
                        continue;
                } else if (ch.element.hasAttribute("data-ignore-positioning")) {
                    continue;
                }
                posElements.push(new ControlElement(ch.element, this._stylesheet));
            }
        }

        if (dockElement.length !== 0) {
            if (dockElement.length === 1) {
                new AlignDockHelperSelfContainer(dockElement[0], this.element);
            } else {
                this._docking(dockElement.map((item) => item.element));
            }
        }

        for (const child of posElements) {
            this.element.appendChild(child.element);
            child.createStyleData();
        }
    }

    public override dispose(): void {
        this.disposing.trigger(this, null);
        this.disposing.removeAll();
        super.dispose();
        this._stylesheet.remove();
    }
}
